import enumsJson from "../../docs/artifacts/data-model/ai-act-solo-business-readiness-data-model-v0.2/rules/enums.v0.2.json";
import businessProfileSchema from "../../docs/artifacts/data-model/ai-act-solo-business-readiness-data-model-v0.2/schemas/business-profile.schema.json";

type Option = { value: string; label: string };
export type OptionGroup = { label: string; values: string[] };
type EnumRules = { enums: Record<string, { enum: string[] }> };

const enumRules = enumsJson as EnumRules;
const businessSchema = businessProfileSchema as {
  properties: Record<string, { enum?: string[]; items?: { enum?: string[] } }>;
};

const labels: Record<string, string> = {
  yes: "Ja",
  no: "Nein",
  deployer: "Deployer",
  provider_non_high_risk: "Provider (nicht-Hochrisiko)",
  provider_high_risk: "Provider (Hochrisiko)",

  // Business profile
  freelancer: "Freelancer",
  consultant: "Berater:in",
  coach: "Coach",
  creator: "Creator",
  solo_marketer: "Solo-Marketer",
  solo_digital_service_provider: "Solo Digital Service Provider",
  solo_agency_owner: "Solo-Agenturinhaber:in",
  expert_personal_brand: "Expert Personal Brand",
  studio_specialist_business: "Studio / Spezialist:in",
  other: "Sonstiges",
  unknown: "Unsicher",
  consulting: "Beratung",
  coaching: "Coaching",
  marketing: "Marketing",
  content_creation: "Content-Erstellung",
  design: "Design",
  copywriting: "Copywriting",
  training: "Training",
  facilitation: "Moderation / Facilitation",
  software_no_code: "Software / No-Code",
  operations: "Operations",
  mostly_b2b: "Überwiegend B2B",
  mostly_b2c: "Überwiegend B2C",
  mixed_b2b_b2c: "Gemischt B2B/B2C",
  public_audience: "Öffentliche Zielgruppe",
  internal_only: "Nur intern",
  hardly_using: "Kaum genutzt",
  testing_occasionally: "Gelegentliches Testen",
  regular_own_work: "Regelmäßig eigene Arbeit",
  regular_client_work: "Regelmäßig Kundenarbeit",
  ai_core_to_service_delivery: "KI ist Kern der Leistung",
  builds_client_ai_workflows: "Baut KI-Workflows für Kunden",
  offers_ai_product: "Bietet KI-Produkt an",

  // Tool categories
  general_purpose_llm: "KI-Chat / Allzweck-KI",
  research_tool: "Recherche-Tool",
  image_generator: "Bildgenerator",
  design_ai_tool: "Design-KI-Tool",
  text_optimization_tool: "Textoptimierung",
  translation_writing_assistant: "Übersetzung / Schreibassistenz",
  transcription_tool: "Transkription",
  meeting_assistant: "Meeting-Assistent",
  automation_tool: "Automation",
  crm_marketing_ai: "CRM-/Marketing-KI",
  website_chatbot: "Website-Chatbot",
  custom_assistant: "Custom Assistant",
  analysis_tool: "Analyse-Tool",
  audio_video_generator: "Audio-/Video-Generator",

  // Use case categories
  research_ideation: "Recherche / Ideenfindung",
  text_optimization: "Textoptimierung",
  summarization: "Zusammenfassung",
  customer_communication: "Kundenkommunikation",
  sales_offer_copy: "Sales-/Angebotstexte",
  strategy_consulting: "Strategie / Beratung",
  image_graphic_creation: "Bild-/Grafikerstellung",
  audio_video_creation: "Audio-/Video-Erstellung",
  meeting_transcription: "Meeting-Transkription",
  automation: "Automation",
  analysis_evaluation: "Analyse / Auswertung",
  chatbot_customer_interaction: "Chatbot / direkte Kundeninteraktion",
  internal_organization: "Interne Organisation",
  digital_product: "Digitales Produkt",
  custom_assistant_workflow: "Custom Assistant Workflow",

  // Context, data, output, review
  own_public_content: "Eigener öffentlicher Content",
  client_work: "Kundenarbeit",
  direct_customer_communication: "Direkte Kundenkommunikation",
  client_workflow_handover: "Workflow-Übergabe an Kunden",
  general_ideas: "Allgemeine Ideen",
  public_information: "Öffentliche Informationen",
  own_business_information: "Eigene Business-Informationen",
  client_briefing_no_personal_data: "Kundenbriefing ohne Personendaten",
  client_content_project_information: "Kunden-/Projektinformationen",
  client_information: "Kundeninformationen",
  public_output: "Öffentlicher Output",
  synthetic_media: "Synthetische Medien",
  internal_output: "Interner Output",
  llm_chat: "LLM Chat",
  image_generation: "Bildgenerierung",
  no_personal_data: "Keine Personendaten",
  confidential_client_data: "Vertrauliche Kundendaten",
  personal_data: "Personenbezogene Daten",
  sensitive_personal_data: "Sensible personenbezogene Daten",
  meeting_transcripts: "Meeting-Transkripte",
  applicant_employee_data: "Bewerber-/Mitarbeiterdaten",
  health_coaching_information: "Gesundheits-/Coaching-Informationen",
  no_input_output_only: "Kein Input, nur Output",
  internal_notes: "Interne Notizen",
  ideas_drafts: "Ideen / Entwürfe",
  client_ready_text: "Kundenfertiger Text",
  public_content: "Öffentlicher Content",
  image_graphic: "Bild / Grafik",
  audio: "Audio",
  video: "Video",
  summary: "Zusammenfassung",
  recommendation: "Empfehlung",
  automatic_customer_reply: "Automatische Kundenantwort",
  decision_support: "Entscheidungsunterstützung",
  always: "Immer",
  mostly: "Meistens",
  only_customer_or_public_output: "Nur bei Kunden-/öffentlichem Output",
  rough: "Grob",
  none: "Keine",
  automatic_without_review: "Automatisch ohne Review",
  automated_decision_about_people: "Automatisierte Entscheidung über Personen",
  human_review_present: "Menschliche Prüfung vorhanden",
  external_review: "Externe Prüfung",
  internal_or_low_risk_pattern: "Internes oder überschaubares Nutzungsmuster",
  tool_documented_with_low_risk_pattern: "Tool mit überschaubarem Nutzungsmuster dokumentiert",
  ai_system_provided_to_clients: "KI-System oder Workflow für Kunden bereitgestellt",
  direct_ai_interaction: "Direkte KI-Interaktion mit Kunden oder Zielgruppen",
  customer_facing_business: "Kundenorientiertes Geschäftsmodell",
  weak_or_unknown_human_review: "Schwache oder unklare menschliche Prüfung",
  uncertain_data_category: "Unklare Datenkategorie",
  customer_effective_output_without_human_review: "Kundenwirksamer Output ohne menschliche Prüfung",
  personal_data_possible: "Personenbezogene Daten möglich",

  // Status labels
  active: "Aktiv",
  planned: "Geplant",
  tested: "Getestet",
  tested_only: "Nur getestet",
  paused: "Pausiert",
  archived: "Archiviert",
  needs_review: "Prüfung empfohlen",
  complete: "Abgeschlossen",
  in_progress: "In Bearbeitung",
  not_started: "Nicht gestartet",
  needs_external_review: "Externe Prüfung empfohlen",
  postponed: "Verschoben",
  ready_to_export: "Exportbereit",
  exported: "Exportiert",
  needs_update: "Aktualisierung empfohlen",
  draft: "Entwurf",
  open: "Offen",
  medium: "Mittel",
  high: "Hoch",
  low: "Niedrig",

  // Role profiles and transparency
  A: "Profil A - interne KI-Nutzung",
  B: "Profil B - KI-unterstützte Kundenarbeit",
  C: "Profil C - KI-Workflow für Kunden",
  D: "Profil D - KI-Produkt oder direkter KI-Kundenkontakt",
  no_external_notice_obvious: "Kein externer Hinweis offensichtlich erforderlich",
  notice_useful: "Hinweis sinnvoll",
  notice_strongly_recommended_or_check: "Hinweis stark empfohlen oder prüfen",
  external_review_recommended: "Externe Prüfung empfohlen",
  not_checked: "Noch nicht geprüft",
  none_needed: "Kein externer Hinweis offensichtlich erforderlich",
  notice_recommended: "Hinweis empfohlen",

  // Entity labels
  tool: "Tool",
  use_case: "Use Case",
  json: "JSON Backup",
  csv: "CSV",
  markdown: "Markdown",
  pdf: "PDF"
  ,
  green: "Grün",
  yellow: "Gelb",
  red: "Rot",
  done: "Erledigt",
  deferred: "Zurückgestellt",
  cancelled: "Abgebrochen",
  critical: "Kritisch"
};

function fromValues(values: string[] = []): Option[] {
  return values.map((value) => ({ value, label: labels[value] ?? humanize(value) }));
}

function humanize(value: string) {
  return value.replaceAll("_", " ").replace(/\b\w/g, (match) => match.toUpperCase());
}

export function modelOptions(enumName: keyof typeof enumRules.enums) {
  return fromValues(enumRules.enums[enumName]?.enum ?? []);
}

export function businessOptions(property: string) {
  const prop = businessSchema.properties[property];
  return fromValues(prop?.enum ?? prop?.items?.enum ?? []);
}

export function modelLabel(value: string) {
  return labels[value] ?? humanize(value);
}

export const options = {
  businessTypes: businessOptions("business_type"),
  serviceAreas: businessOptions("service_areas"),
  customerTypes: businessOptions("customer_type"),
  aiUsageMaturity: businessOptions("ai_usage_maturity"),
  toolCategories: modelOptions("tool_category"),
  useCaseCategories: modelOptions("use_case_category"),
  usageContexts: modelOptions("usage_context"),
  dataCategories: modelOptions("data_category"),
  outputTypes: modelOptions("output_type"),
  humanReviewLevels: modelOptions("human_review_level")
};

export const optionGroups = {
  useCaseCategories: [
    { label: "Text & Content", values: ["content_creation", "text_optimization", "summarization", "sales_offer_copy"] },
    { label: "Recherche & Beratung", values: ["research_ideation", "strategy_consulting", "analysis_evaluation"] },
    { label: "Kundenkommunikation", values: ["customer_communication", "chatbot_customer_interaction"] },
    { label: "Medien", values: ["image_graphic_creation", "audio_video_creation"] },
    { label: "Workflows & Organisation", values: ["automation", "meeting_transcription", "internal_organization", "custom_assistant_workflow"] },
    { label: "Produkte & Sonstiges", values: ["digital_product", "other", "unknown"] }
  ],
  toolCategories: [
    { label: "Chat & Text", values: ["general_purpose_llm", "text_optimization_tool", "translation_writing_assistant", "custom_assistant"] },
    { label: "Recherche & Analyse", values: ["research_tool", "analysis_tool"] },
    { label: "Medien & Design", values: ["image_generator", "design_ai_tool", "audio_video_generator"] },
    { label: "Meeting & Transkription", values: ["transcription_tool", "meeting_assistant"] },
    { label: "Automation & Business", values: ["automation_tool", "crm_marketing_ai", "website_chatbot"] },
    { label: "Sonstiges", values: ["other", "unknown"] }
  ],
  usageContexts: [
    { label: "Intern", values: ["internal_only"] },
    { label: "Öffentlich", values: ["own_public_content"] },
    { label: "Kundenbezogen", values: ["client_work", "direct_customer_communication"] },
    { label: "Produkt / Übergabe", values: ["digital_product", "client_workflow_handover"] },
    { label: "Unsicher", values: ["unknown"] }
  ],
  dataCategories: [
    { label: "Unkritisch / allgemein", values: ["general_ideas", "public_information", "own_business_information", "no_input_output_only"] },
    { label: "Kundenbezogen", values: ["client_briefing_no_personal_data", "client_content_project_information", "confidential_client_data"] },
    { label: "Personenbezogen", values: ["personal_data", "meeting_transcripts", "applicant_employee_data"] },
    { label: "Sensibel / prüfpflichtig", values: ["sensitive_personal_data", "health_coaching_information"] },
    { label: "Unsicher", values: ["unknown"] }
  ],
  outputTypes: [
    { label: "Intern", values: ["internal_notes", "ideas_drafts", "summary"] },
    { label: "Kundenfertig / öffentlich", values: ["client_ready_text", "public_content"] },
    { label: "Medien", values: ["image_graphic", "audio", "video"] },
    { label: "Analyse / Entscheidung", values: ["analysis_evaluation", "recommendation", "decision_support"] },
    { label: "Automatisiert / Sonstiges", values: ["automatic_customer_reply", "other", "unknown"] }
  ],
  humanReviewLevels: [
    { label: "Klar geprüft", values: ["always", "mostly", "only_customer_or_public_output"] },
    { label: "Schwach oder keine Prüfung", values: ["rough", "none", "automatic_without_review"] },
    { label: "Unsicher", values: ["unknown"] }
  ],
  businessTypes: [
    { label: "Solo-Dienstleistung", values: ["freelancer", "consultant", "coach", "solo_digital_service_provider", "solo_agency_owner"] },
    { label: "Content / Marke / Studio", values: ["creator", "solo_marketer", "expert_personal_brand", "studio_specialist_business"] },
    { label: "Sonstiges", values: ["other", "unknown"] }
  ],
  serviceAreas: [
    { label: "Beratung & Wissen", values: ["consulting", "coaching", "training", "facilitation"] },
    { label: "Marketing & Content", values: ["marketing", "content_creation", "copywriting", "design"] },
    { label: "Technik & Betrieb", values: ["software_no_code", "operations"] },
    { label: "Sonstiges", values: ["other", "unknown"] }
  ],
  customerTypes: [
    { label: "Kundenstruktur", values: ["mostly_b2b", "mostly_b2c", "mixed_b2b_b2c", "public_audience"] },
    { label: "Intern / unsicher", values: ["internal_only", "unknown"] }
  ],
  aiUsageMaturity: [
    { label: "Einstieg", values: ["hardly_using", "testing_occasionally"] },
    { label: "Regelmäßige Nutzung", values: ["regular_own_work", "regular_client_work"] },
    { label: "KI als Leistung", values: ["ai_core_to_service_delivery", "builds_client_ai_workflows", "offers_ai_product"] },
    { label: "Unsicher", values: ["unknown"] }
  ]
} satisfies Record<string, OptionGroup[]>;

export function groupedOptions(optionList: Option[], groups: OptionGroup[]) {
  const byValue = new Map(optionList.map((option) => [option.value, option]));
  const used = new Set<string>();
  const grouped = groups
    .map((group) => ({
      label: group.label,
      options: group.values.map((value) => byValue.get(value)).filter(Boolean) as Option[]
    }))
    .filter((group) => group.options.length > 0);
  grouped.forEach((group) => group.options.forEach((option) => used.add(option.value)));
  const rest = optionList.filter((option) => !used.has(option.value));
  return rest.length ? [...grouped, { label: "Weitere", options: rest }] : grouped;
}
